// extracted by mini-css-extract-plugin
export default {"sort-menu__option-inner":"lsf-sort-menu__option-inner","sort-menu__title":"lsf-sort-menu__title","sort-menu__icon":"lsf-sort-menu__icon"};
    if(module.hot) {
      // 1637785522102
      var cssReload = require("/Users/nicholasrq/Git/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  